module.exports = __webpack_public_path__ + "static/fonts/iconfont.abcee29e.ttf";